import UseGetData from "../../../HookAxios/getdata";
import { GET_REQUEST } from "../../../HooksApi/useApi";
import { Section, TextSection } from "./StyledPrivacyPolicy"
import Parser from 'html-react-parser';
import Dots from '../../../Components/Loader/Dots';
const PrivacyPolicyComp = () => {
    const { isLoading, data }
        = GET_REQUEST({ queryKey: "privacy_policy", request: () => UseGetData('privacy_policy'), enabled: true })

    return (
        <Section>
            <TextSection >
                {!isLoading ?
                    Parser(data.data.data?.content)
                    : <Dots />}
            </TextSection>
            {/* <RightSection>
                <TextHeading>
                    سياسة الخصوصية
                </TextHeading>
                <TextTitle>
                    1-عنوان عريض
                </TextTitle>
                <TextDesc>
                    تظل الفلسفات التربوية وأهدافها مجردات ما لم تجد طريقها إلى المناهج التعليمية التي تعمل على ترجمتها إلى أداءات ملموسة، ذلك أن المناهج التعليمية الحديثة أصبحت تجسد و تترجم الفكر التربوي واالجتماعي إلى واقع تعليمي معين، من خالل ما يتحدد بما لدينا من مفهوم واضح عن معنى التربية المطلوبة لهذا المجتمع وطبيعتها ووسائطها التربوية ومصادرها، ومن ثم فإن المناهج التعليمية تعتبر الترجمة العملية ألهداف التربية والتعليم وخططها واتجاهاتها في كل مجتمع، وتطوير ها يعني أشياء كثيرة بحسب ما يرى المخططون، أو ما يطلب منهم.
                </TextDesc>
                <TextTitle>
                    2-عنوان عريض
                </TextTitle>
                <TextDesc>
                    تظل الفلسفات التربوية وأهدافها مجردات ما لم تجد طريقها إلى المناهج التعليمية التي تعمل على ترجمتها إلى أداءات ملموسة، ذلك أن المناهج التعليمية الحديثة أصبحت تجسد و تترجم الفكر التربوي واالجتماعي إلى واقع تعليمي معين، من خالل ما يتحدد بما لدينا من مفهوم واضح عن معنى التربية المطلوبة لهذا المجتمع وطبيعتها ووسائطها التربوية ومصادرها، ومن ثم فإن المناهج التعليمية تعتبر الترجمة العملية ألهداف التربية والتعليم وخططها واتجاهاتها في كل مجتمع، وتطوير ها يعني أشياء كثيرة بحسب ما يرى المخططون، أو ما يطلب منهم.
                </TextDesc>
                <TextTitle>
                    3-عنوان عريض
                </TextTitle>
                <TextDesc>
                    تظل الفلسفات التربوية وأهدافها مجردات ما لم تجد طريقها إلى المناهج التعليمية التي تعمل على ترجمتها إلى أداءات ملموسة، ذلك أن المناهج التعليمية الحديثة أصبحت تجسد و تترجم الفكر التربوي واالجتماعي إلى واقع تعليمي معين، من خالل ما يتحدد بما لدينا من مفهوم واضح عن معنى التربية المطلوبة لهذا المجتمع وطبيعتها ووسائطها التربوية ومصادرها، ومن ثم فإن المناهج التعليمية تعتبر الترجمة العملية ألهداف التربية والتعليم وخططها واتجاهاتها في كل مجتمع، وتطوير ها يعني أشياء كثيرة بحسب ما يرى المخططون، أو ما يطلب منهم.
                </TextDesc>
            </RightSection>
            <LeftSection>
                <Image src={prev} />
            </LeftSection> */}
        </Section>

    )
}

export default PrivacyPolicyComp